module.exports = __webpack_public_path__ + "static/media/ic_pf_insurance.6db1b73d.svg";